import { PropTypes } from "prop-types";
import { connect } from "react-redux";
/**
 * HOC that Handles whether or not the user is allowed to see the page.
 * @param {array} allowedRoles - user roles that are allowed to see the page.
 * @returns {Component}
 */
export default function Authorization(allowedRoles) {
    return (WrappedComponent) => {
        const WithAuthorization = ({ user, ...props }) => {
            if (allowedRoles.includes(user.roles[0].authority)) {
                return <WrappedComponent {...props} />;
            }
        };

        WithAuthorization.propTypes = {
            user: PropTypes.object,
        };

        return connect((state) => ({
            user: state.authReducer.payload,
        }))(WithAuthorization);
    };
}
